/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SMRuleListConfiguration,
    SMRuleListConfigurationFromJSON,
    SMRuleListConfigurationToJSON,
    SMRuleListItem,
    SMRuleListItemFromJSON,
    SMRuleListItemToJSON,
    SMRuleListQuery,
    SMRuleListQueryFromJSON,
    SMRuleListQueryToJSON,
} from '../models';

export interface ApiSearchManagerSMRuleListDataPostRequest {
    sMRuleListQuery?: SMRuleListQuery;
}

export interface ApiSearchManagerSMRuleListDeleteDeleteRequest {
    id?: string;
}

/**
 * no description
 */
export class SMRuleListApi extends runtime.BaseAPI {

    /**
     */
    async apiSearchManagerSMRuleListConfigurationGetRaw(): Promise<runtime.ApiResponse<SMRuleListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SMRuleListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchManagerSMRuleListConfigurationGet(): Promise<SMRuleListConfiguration> {
        const response = await this.apiSearchManagerSMRuleListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMRuleListDataPostRaw(requestParameters: ApiSearchManagerSMRuleListDataPostRequest): Promise<runtime.ApiResponse<Array<SMRuleListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SMRuleListQueryToJSON(requestParameters.sMRuleListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SMRuleListItemFromJSON));
    }

    /**
     */
    async apiSearchManagerSMRuleListDataPost(requestParameters: ApiSearchManagerSMRuleListDataPostRequest): Promise<Array<SMRuleListItem>> {
        const response = await this.apiSearchManagerSMRuleListDataPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchManagerSMRuleListDeleteDeleteRaw(requestParameters: ApiSearchManagerSMRuleListDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchManager/SMRuleList/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiSearchManagerSMRuleListDeleteDelete(requestParameters: ApiSearchManagerSMRuleListDeleteDeleteRequest): Promise<void> {
        await this.apiSearchManagerSMRuleListDeleteDeleteRaw(requestParameters);
    }

}
